import typeOf from './typeOf';

const lct = {
    parse(str) {
        if (str.charAt(0) === '#' || str.charAt(0) === '?') {
            str = str.substring(1);
        }

        let array = str.split('&');
        let ob = {};

        array.map((item) => {
            let itemArray = item.split('=');

            if (typeOf.isNumeric(itemArray[1])) {
                itemArray[1] = +itemArray[1];
            }

            ob[itemArray[0]] = decodeURIComponent(itemArray[1]);
        });

        return ob;
    },

    stringify(ob) {
        let str = '';
        for (let key in ob) {
            const v = ob[key];
            if (v === undefined || v === null) continue;
            if (Array.isArray(v)) {
                v.forEach((item) => {
                    if (item === undefined || item === null) return;
                    str += `&${encodeURIComponent(key)}=${encodeURIComponent(item)}`;
                });
            } else {
                str += `&${encodeURIComponent(key)}=${encodeURIComponent(v)}`;
            }
        }
        return str.substring(1);
    }
};

export default lct;
